import { render, staticRenderFns } from "./authorizedPhone.vue?vue&type=template&id=6ae5c672&scoped=true"
import script from "./authorizedPhone.vue?vue&type=script&lang=js"
export * from "./authorizedPhone.vue?vue&type=script&lang=js"
import style0 from "./authorizedPhone.vue?vue&type=style&index=0&id=6ae5c672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5c672",
  null
  
)

export default component.exports